import { render, staticRenderFns } from "./drawRing.vue?vue&type=template&id=4b6cbdb1&"
import script from "./drawRing.vue?vue&type=script&lang=js&"
export * from "./drawRing.vue?vue&type=script&lang=js&"
import style0 from "./drawRing.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports